<template>
  <div class="Page">
    <HeaderSection 
      title="Over Energieke Verhalen"
      :closeLinkTo="{ name: 'home'}">
      <p>
        Op dit platform presenteren we interessante en leerzame verhalen die gaan over de energietransitie in woningen binnen provincie Utrecht.
      </p>
    </HeaderSection>

    <ContentSection>
      <SectionHeader label="Waarom?! Eilandjes!" />
      <p>
        Momenteel zijn er veel verschillende platforms te vinden die vrijwel allemaal hetzelfde doel hebben, namelijk informeren. 
      </p>
      <p>
        Wij zien deze platforms als losse “eilandjes”, maar met behulp van Energieke Verhalen worden deze platforms aan elkaar verbonden. 
      </p>
      <p>
        Er wordt niet een nieuw eiland gecreëerd. Er zal juist gebruik worden gemaakt van de content die momenteel ook al te vinden is. 
        <!-- Door deze op een gebruiksvriendelijke manier te ontsluiten met behulp van een tijdlijn, zullen de verhalen overzichtelijk worden getoond aan de bezoeker. -->
      </p>
    </ContentSection>
    <ContentSection>
      <SectionHeader label="Doel: 3 Pijlers" />
      <ul>
        <li>
          We maken geen nieuw platform maar combineren bestaande en maken ze daarmee meteen beter zichtbaar. 
        </li>
        <li>
          We plaatsen geen technische momentopnamen maar vertellen trotse verhalen met hun tijdlijn, tips, tops en flops. 
        </li>
        <li>
          We plaatsen geen losse verhalen maar koppelen ze aan elkaar door middel van het leggen van verbanden tussen de individuele projecten.
        </li>
      </ul>
    </ContentSection>
    <ContentSection>
      <SectionHeader label="Het team" />
      <!-- Zolang de colofon pagina niet beschikbaar is -->
      <p>
        Het team waarmee Energieke Verhalen is opgestart bevatte: Bart Kloostra, Frank van der Wal, Maartje Wieling, Wouter van Dam, Arthur Lippus, Marianne van Dijk en Joop Machielse
      </p>
      <!-- Stage link -->
    </ContentSection>
    <ContentSection>
      <SectionHeader label="Sponsoren" />
      <p>
        Het opstarten van Energieke Verhalen is mede mogelijk gemaakt door: ANNE, Journeyworks en Provincie Utrecht
      </p>
      <p>
        <Link 
          :to="{ name: 'page-contact' }" 
          label="Sluit je bij ons aan!" />        
      </p>

    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';
import SectionHeader from '@/components/section/Header';
import Link from '@/components/Link';

export default {
  name: 'PageAbout',
  components: {
    HeaderSection,
    ContentSection,
    SectionHeader,
    Link
  }
}
</script>
